import { indicadoresEsfEapConfig } from './esf_eap'
import { indicadoresEsbConfig } from './esb'

/**
 * Retorna o mapa unificado de todos os indicadores.
 *
 * @type {Object}
 */
export const indicadoresConfig = {
  ...indicadoresEsfEapConfig,
  ...indicadoresEsbConfig,
}
